export default "../media/bg_landing_2_large.17194611b6d3cf428f2bec43870ad4b2.jpeg";